const state = {
  chats: [],
  comments: [],
};

export default state;
